<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <!-- Title page -->
                    <h1 class="page__title">
                        {{ $t(titlePage) }}
                    </h1>
                </CCol>
                <CCol> </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <div class="filters-bar mb-3 d-flex align-items-center">
                    <div class="filters-group d-flex align-items-center mr-3">
                        <FilterDate @updateData="updateData" />
                    </div>
                    <div class="actions-group">
                        <ButtonBack />
                    </div>
                </div>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'logs',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <strong>{{ $t("balancer_log") }}</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.logs.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.logs.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.logs.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.logs.rows"
                                    v-bind="tables.logs"
                                    :resizable="false"
                                    size="sm"
                                >
                                    <template #over-table>
                                        <div
                                            class="d-flex table-tools justify-content-end align-items-center px-2 py-2"
                                        >
                                            <div
                                                class="d-flex align-items-center table-custom"
                                            >
                                                <FilterFields
                                                    :fields="tables.logs.fields"
                                                    @filter="updateData"
                                                />
                                                <TableSettings
                                                    :allFields="
                                                        tables.logs.allFields
                                                    "
                                                    :activeFields.sync="
                                                        tables.logs.fields
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </template>
                                    <template #event="{ item }">
                                        {{ $t(item.event) }}
                                    </template>
                                    <template #outcome="{ item }">
                                        <CBadge
                                            v-if="item.outcome"
                                            :color="outcomeColor(item.outcome)"
                                        >
                                            {{ $t(item.outcome) }}
                                        </CBadge>
                                        <span v-else>-</span>
                                    </template>
                                    <template #client_id="{ item }">
                                        <span :title="item.client_name">
                                            {{
                                                item.client_name ||
                                                item.client_id ||
                                                "-"
                                            }}
                                        </span>
                                    </template>
                                    <template #input_campaign_id="{ item }">
                                        <span :title="item.input_campaign_name">
                                            {{
                                                item.input_campaign_name ||
                                                item.input_campaign_id ||
                                                "-"
                                            }}
                                        </span>
                                    </template>
                                    <template #enqueue_source="{ item }">
                                        {{
                                            item.enqueue_source
                                                ? $t(item.enqueue_source)
                                                : "-"
                                        }}
                                    </template>
                                    <template #delivery_method="{ item }">
                                        {{ item.delivery_method || "-" }}
                                    </template>
                                    <template #http_status="{ item }">
                                        {{ item.http_status || "-" }}
                                    </template>
                                    <template #message="{ item }">
                                        <span
                                            class="log-message"
                                            :title="item.message"
                                        >
                                            {{ item.message || "-" }}
                                        </span>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.logs.total_pages > 0">
                                <div
                                    class="position-relative d-flex justify-content-between"
                                >
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.logs.page"
                                        :pages="tables.logs.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.logs.loading"
                                    />
                                    <div
                                        class="d-flex align-items-center justify-content-end"
                                    >
                                        <label
                                            class="mb-0 mr-2"
                                            style="white-space: nowrap"
                                        >
                                            {{ $t("Item per page") }}:
                                        </label>
                                        <select
                                            class="form-control mr-2"
                                            style="width: auto"
                                            v-model="tables.logs.rows"
                                            @change="
                                                itemPerPage($event.target.value)
                                            "
                                        >
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'logs',
                    })
                "
            >
                <template #title>
                    {{ $t("There are no balancer logs in this period") }}
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'logs',
                            })
                        "
                        @click="cleanFiltersAdvance('logs'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import CCTable from "~/components/CCTable";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import TableSettings from "£lement/TableSettings";
import NoItemsContainer from "~/components/NoItemsContainer";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import { eraser } from "~/assets/icons/js/eraser";
import ClientGroupLogsTableConfig, {
    LOG_OUTCOME_COLORS,
} from "./config/tables/ClientGroupLogs.js";
import { adapterBalancerLogsQuery } from "~/utils/balancerLogsQuery.js";

export default {
    name: "DeliveryCampaignGroupLogsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        CCTable,
        ButtonBack,
        FilterDate,
        FilterFields,
        TableSettings,
        NoItemsContainer,
    },
    icons: {
        eraser,
    },
    data() {
        return {
            tables: {
                logs: ClientGroupLogsTableConfig,
            },
        };
    },
    computed: {
        titlePage: function () {
            return this.$route.meta.title
                ? this.$route.meta.title
                : this.$route.name;
        },
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        outcomeColor(outcome) {
            return LOG_OUTCOME_COLORS[outcome] || "secondary";
        },
        /**
         * El endpoint solo filtra salidas y entradas por id, asi que las
         * opciones del select se sacan de las stats del mismo rango, que son
         * las unicas que traen el id junto a su nombre.
         */
        async loadFilterOptions() {
            try {
                const stats = await this.fetcher({
                    url: `/shipment.balancing.api/client-groups/${this.uuid}/stats`,
                    query: {
                        from: this.storeFrom,
                        to: this.storeTo,
                    },
                });

                this.setFilterOptions(
                    "client_id",
                    (stats.per_output || []).map((output) => ({
                        value: output.client_id,
                        label: output.client_name || output.client_id,
                    }))
                );
                this.setFilterOptions(
                    "input_campaign_id",
                    (stats.per_input || []).map((input) => ({
                        value: input.input_campaign_id,
                        label:
                            input.input_campaign_name ||
                            input.input_campaign_id,
                    }))
                );
            } catch (error) {
                // Sin opciones el log sigue siendo usable: solo se pierde el
                // desplegable de salida y entrada.
                this.setFilterOptions("client_id", []);
                this.setFilterOptions("input_campaign_id", []);
            }
        },
        setFilterOptions(fieldKey, options) {
            const field = this.tables.logs.fields.find(
                (item) => item.key === fieldKey
            );
            if (field && field._filter) {
                field._filter.options = options;
            }
        },
        async updateData() {
            await Promise.all([
                this.loadFilterOptions(),
                this.updateTable({
                    tableName: "logs",
                    url: `/shipment.balancing.api/client-groups/${this.uuid}/logs/pagination`,
                    adapterFilters: adapterBalancerLogsQuery,
                }),
            ]);

            this.tables.logs.allFields = this.getTableAllFields("logs");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss">
.log-message {
    display: inline-block;
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
</style>
